/* import __COLOCATED_TEMPLATE__ from './ticket-custom-state-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();